<div class="blog-preview-wrapper">
  <div class="blog-banner">
    <div class="blog-banner-content">
      <div class="blog-title">Terms and Conditions</div>
      <div class="blog-meta">{{ lastUpdatedBy | date : "dd MMM yyyy" }} |</div>
    </div>
  </div>

  <div class="blog-container">
    <div class="container">
      <div class="container-fluid">
        <div class="card-style" *ngFor="let tnc of tncList">
          <div class="card-style-title">{{ tnc.type }}</div>

          <div
            class="accordion"
            [id]="'accordion' + tnc.type.split(' ').join('')"
          >
            <div
              class="accordion-item"
              *ngFor="let data of tnc.tncList; index as i"
            >
              <h2 class="accordion-header" [id]="'heading_' + i">
                <button
                  type="button"
                  class="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="
                    '#collapse_' + tnc.type.split(' ').join('') + i
                  "
                  [attr.aria-controls]="'collapse_' + i"
                >
                  {{ data.title }}
                </button>
              </h2>

              <div
                [id]="'collapse_' + tnc.type.split(' ').join('') + i"
                class="collapse"
                [attr.data-bs-parent]="
                  '#accordion' + tnc.type.split(' ').join('')
                "
                [attr.aria-labelledby]="'heading_' + i"
              >
                <div class="tnc-body">
                  <hr class="tnc-line" />
                  <div
                    [innerHTML]="data?.description"
                    class="prose prose-neutral max-w-none"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
